<template>
  <BModal name="login-signup-modal" :dialog-class="{ 'modal-xl': true }" @open="setDefaultRole" @close="resetModal">
    <template #default>
      <div class="grid-cols-2 lg:grid">
        <div class="relative flex flex-col overflow-hidden bg-primary max-lg:hidden">
          <img src="./images/bulle.svg" alt="Illustration" class="" />
          <div class="absolute inset-0 flex p-8 xl:p-16">
            <div class="relative grow rounded-lg bg-white/10 p-8 backdrop-blur-xl">
              <FormTitle :view="view" class="relative z-10 text-left text-white" />
              <img
                src="./images/human.png"
                alt="Illustration"
                class="absolute -right-4 bottom-0 w-[80%] xl:-right-8 xl:w-[90%]"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col p-4">
          <div class="flex grow flex-col justify-center">
            <Signup v-if="view === 'signup'" :default-role="defaultRole" />
            <Login v-if="view === 'login'" />
          </div>
          <div class="my-2 text-center">
            <div id="gdpr-note"></div>
            <a
              v-if="view === 'signup'"
              href
              class="cursor-pointer font-medium text-dark"
              @click.prevent.stop="view = 'login'"
            >
              Déjà inscrit&nbsp;? Se connecter
            </a>
            <a v-else href class="cursor-pointer font-medium text-dark" @click.prevent.stop="view = 'signup'">
              Pas encore de compte&nbsp;? S'inscrire
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #bottom-addon></template>
  </BModal>
</template>

<script>
import BModal from '@/apps/shared/components/b-modal.vue'
import Signup from './components/Signup.vue'
import Login from './components/Login.vue'
import FormTitle from './components/FormTitle.vue'

export default {
  components: {
    BModal,
    Signup,
    Login,
    FormTitle
  },
  data() {
    return {
      view: 'signup',
      defaultRole: null
    }
  },
  methods: {
    setDefaultRole(link) {
      this.defaultRole = link.dataset.defaultUserRole
    },
    resetModal() {
      this.view = 'signup'
      this.defaultRole = null
    }
  }
}
</script>
